<!-- 布局 -->
<template>
  <div class="layout-box">
    <div class="layout-header">
      <div class="header-left">
        <div class="wrapper-header">
          <div class="header-main-title" @click="jumpLink">
            <img
              src="/images/icons/hui.png"
              style="height: 28px; vertical-align: text-bottom"
            />
            药品追溯监管身份认证平台
          </div>
        </div>
      </div>

      <div class="header-right">
        <div class="work-loginout" @click="logout">
          <img src="/images/icons/loginout.png" alt="" />
          <span>退出</span>
        </div>
        <!-- <UserInfo /> -->
      </div>
    </div>

    <div class="layout">
      <!-- 左侧菜单 -->
      <div class="navbar">
        <NavSide />
      </div>
      <!-- 右侧内容 -->
      <div class="main-container">
        <div class="main-wrap">
          <div class="main-wrap-box">
            <div class="tabs-wrap">
              <PageTabs @change="onChangeTabs"></PageTabs>
            </div>
          </div>
        </div>
        <div class="content">
          <slot></slot>
        </div>
      </div>
    </div>
    <!-- <UpdateLoginPassword
      :dialogVisible="userInfo.firstLogin"
      :showClose="false"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showCancelFlag="false"
      :closeUserDialog="closeUserDialog"
    /> -->
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
// import UserInfo from "@/components/user-info/user-info.vue";
import NavSide from "../page-menu/Index.vue";
// import UpdateLoginPassword from "../user-info/update-login-password.vue";
import PageTabs from "@/components/page-tabs/Index.vue"; // 多页签组件
import CommonAPI from "@/api/common.js";

export default {
  data() {
    return {
      NavSideShow: true,
      current: "",
      parentRoute: undefined,
      timer: null,
      scollLeft: 0,
      // isCollapse: true
    };
  },
  computed: {
    ...mapState([
      "userInfo",
      "menus",
      "urlCookie",
      "keepAliveInstance",
      { activeTab: (state) => state.tabs.activeTab },
    ]),
  },
  watch: {
    $route: {
      deep: true,
      handler(newRoute) {
        if (newRoute) {
          this.NavSideShow = true;
        }
        // this.parentRoute = this.getBreadNav(newRoute);
        // this.current = this.getCurrentNav(newRoute);
      },

      immediate: true,
    },
    "activeTab.index": {
      deep: true,
      handler(value) {
        if (value > -1) {
          this.onChangeTabs(null, value);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // this.initMenu()
    // this.getButtonAuth()
  },
  methods: {
    ...mapMutations(["setAuthTreeData", "setMenus", "setAuthButtonList"]),
    // 页签变更自动响应滚动条
    onChangeTabs(tabs, index) {
      this.$nextTick(() => {});
      const $refScroll = this.$refs.refScroll.$el;
      const $container = $refScroll.querySelector(".happy-scroll-container");
      const $content = $container.querySelector(".happy-scroll-content");
      const $tabs = $content.querySelectorAll(".tab-item");
      const $tab = $tabs[index];
      if (!$tab) {
      }
      const $tabOffset = {
        x: $tab.offsetLeft,
        y: $tab.offsetTop,
        w: $tab.offsetWidth,
        h: $tab.offsetHeight,
      };
      const offsetX = $tabOffset.x + $tabOffset.w - this.scollLeft;
      if (offsetX > $container.offsetWidth) {
        // 可视范围右侧
        this.scollLeft = this.scollLeft + offsetX - $container.offsetWidth + 20;
      }
      if ($tabOffset.x < this.scollLeft) {
        // 可视范围左侧
        this.scollLeft = $tabOffset.x;
      }
    },
    // crumbTips() {
    //   this.dialogVisible = true
    // },
    getBreadNav(route = {}) {
      return this.menus.find((menu) => {
        return (
          menu.children && menu.children.find((m) => m.link === route.path)
        );
      });
    },
    getCurrentNav(route = {}) {
      let nav = {};
      this.menus.forEach((menu) => {
        if (menu.children) {
          const r = menu.children.find((m) => m.link === route.path);
          r && (nav = r);
        }
      });
      return nav;
    },
    // 初始化可使用的菜单
    initMenu() {
      CommonAPI.initMenuCommon({ authType: "0" }, (callback) => {
        let menuList = [];
        if (callback.status == "S" && callback.data) {
          menuList = callback.data;
          const menus = this.formatMenus(menuList);
          this.setMenus(menus);
        }
      });
    },
    // 格式化菜单返回值 （统一字段名）
    formatMenus(
      list = [],
      opt = {
        children: "subAuthorityVo",
      }
    ) {
      return list.map((item) => {
        item.children = item[opt.children] || [];
        if (item[opt.children] && item[opt.children].length) {
          return {
            ...item,
            children: this.formatMenus(item[opt.children]),
          };
        } else {
          return item;
        }
      });
    },
    // 初始化可使用的按钮
    getButtonAuth() {
      this.$request({
        url: "/index/initMenu",
        data: {
          authType: "",
        },
      }).then((res) => {
        res = res || [];
        let btnList = [];
        res.map((item) => {
          if (item.subAuthorityVo && item.subAuthorityVo.length > 0) {
            item.subAuthorityVo.map((option) => {
              if (option.authorityBtnVo && option.authorityBtnVo.length > 0) {
                option.authorityBtnVo.map((val) => {
                  btnList.push(val.id);
                });
              }
            });
          } else {
            if (item.authorityBtnVo && item.authorityBtnVo.length > 0) {
              item.authorityBtnVo.map((val) => {
                btnList.push(val.id);
              });
            }
          }
        });
        this.setAuthButtonList(btnList);
      });
    },
    closeUserDialog() {
      this.dialogVisible = false;
    },
    // 退出
    logout() {
      let params = {
        gagauthtoken: localStorage.getItem('token'),
      };
      CommonAPI.logout(params, (callback) => {
        if (callback.status == "S") {
          window.clearVuexAlong();
          // this.$router.push("/login");
          var host = window.location.host;
          if (host.includes(".goago.cn")) {
            this.$router.push("/login");
          } else {
            window.location.href = 'https://zhjg.nmpa.gov.cn/idp/authcenter/ActionAuthChain?entityId=isp'
          }
        }
      });
    },
    // 跳转到工作台
    jumpLink() {
      this.$router.push({
        name: 'Work'
      })
    }
  },
  components: {
    // UserInfo,
    NavSide,
    // UpdateLoginPassword,
    PageTabs,
  },
};
</script>

<style lang="stylus" scoped>
.layout-box
  height 100vh

  .layout-header
    height: 50px;
    line-height: 50px;
    background: #0b51c1;
    box-sizing border-box;
    padding 0 24px;
    display flex;
    .header-left
      // flex: 1;
      .wrapper-header {
        display: flex;
        align-items: center;
        justify-content: left;
        padding-bottom: 40px;
        .header-main-title {
          font-size: 20px;
          font-family: AlibabaPuHuiTi_2_105_Heavy, AlibabaPuHuiTi_2_105_Heavy-Regular;
          font-weight: 400;
          color: #ffffff;
          cursor pointer
        }
      }
    .header-right
      flex: 1;
      text-align right;
      .work-loginout {
        // margin: 24px 24px 0 0;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        img {
          height: 16px;
          margin-right: 4px;
          vertical-align: sub;
        }
      }
  .layout
    // height 100%
    height calc(100vh - 50px)
    display flex
    background #F6F7FB
    overflow-y auto
    .navbar
      background #F6F7FB
      font-weight bold
      overflow-y auto
      box-sizing border-box
    .main-container
      flex 1
      font-weight 400
      position relative
      background #F6F7FB
      display flex
      flex-direction column
      overflow auto;
      height 100%;
    .main-wrap
      box-sizing border-box
      background: #F6F7FB;
      display flex
      flex-direction column
      overflow auto;
      margin-top 4px

      .main-wrap-box
        // margin-top 24px;
        margin-right 24px;
        box-shadow: 1px 1px 2px 0px rgba(0,0,0,0.04);

      .tabs-wrap
        box-sizing border-box
        flex: 1;
    .content
      background #ffffff
      position: absolute;
      top: 44px;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: auto;
      padding: 0 24px;
      padding-bottom 24px;
    .NavSideContent
      padding 0 24px
      position absolute
      top 40px
      left 0
      right 0
      bottom 0
      overflow auto
      padding 0 20px
</style>
